export const CHATBOT_API_URL = process.env.NEXT_PUBLIC_CHATBOT_API_URL
export const CHATBOT_CUSTOMER = process.env.NEXT_PUBLIC_CHATBOT_CUSTOMER

export const ChatbotPages = [
    /^\/about-us$/,
    /^\/categories\//,
    /^\/brands\//,
    /^\/$/,
    /^\/faq$/,
    /^\/profile\//,
    /^\/tags\//,
]
